<div class="ec-member-plants-container" fxLayout="column" fxLayoutGap="15px"
     *appVar="hierarchyEntity|async as hierarchyEntity">

    <!-- top bar -->
    <app-filter-bar
            [showNullData]="showNullData"
            [config]="billingPeriodCfg"
            [billingPeriod]="billingPeriod"
            [useFilter]="true"
            [showGSEBtn]="false"
            [templateIsDownloading]="templateIsDownloading"
            (billingPeriodEventEmitter)="onChangeBillingPeriod($event)">
        <!--            [response]="summary"-->
        <!--            (exportDataEventEmitter)="exportEconomicsToExcel()"-->
    </app-filter-bar>

    <!-- info section -->

    <!-- estimated data label -->
    <div *ngIf="dataSourceInfo" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="txt-h-12-4 mb-20">
       <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
           <app-icon icon-color-h [name]="dataSourceInfo.iconName"></app-icon>
           <div>{{ dataSourceInfo.title|i18n }}</div>
           <app-icon icon-color-h name="fas-info-circle" [title]="dataSourceInfo.iconTitle|i18n"></app-icon>
       </div>
        <div *ngIf="isGSE"  fxLayout="row" fxLayoutAlign="end center">
            <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start start">
                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                    <span class="legend-dot accent-variant"></span>
                    <span class="txt-s-12-4">{{ 'Estimated value'|i18n }}</span>
                </div>
                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                    <span class="legend-dot accent"></span>
                    <span class="txt-s-12-4">{{ 'GSE data'|i18n }}</span>
                </div>
            </div>
        </div>
    </div>

    <div fxLayout="column" fxLayoutGap="12px">
        <div fxLayout="column" class="table-back mt-20" fxLayoutGap="20px">
            <ng-container *ngIf="isDetailViewable(hierarchyEntity); else unviewableEntity">
                <ng-container *ngIf="pods; else loadingPlants">
                    <ng-container *ngIf="pods.length > 0">
                        <table mat-table app-table [dataSource]="pods"
                               *appVar="currentPod" multiTemplateDataRows
                               class="plant-table">
                            <ng-container matColumnDef="chevron">
                                <td fxFlex="3" mat-cell *matCellDef="let row"
                                    class="cell first-cell" [ngClass]="{'expanded': row === currentPod}">
                                    <app-icon class="ml-12"
                                              [name]="row === currentPod ? 'fal-chevron-down' : 'fal-chevron-right'"
                                              [hidden]="!row.isActive">
                                    </app-icon>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <td fxFlex="20" mat-cell *matCellDef="let row" class="cell">
                                    <app-icon icon-color-h name="fal-network-wired" class="mr-10"></app-icon>
                                    <div class="txt-h-16-5"> {{ row.name }}</div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="pod">
                                <td fxFlex="20" mat-cell class="cell" *matCellDef="let row">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                            <div class="txt-s-14-4 mr-10">POD:</div>
                                            <div class="txt-s-14-4">{{ row.pod || '-' }}</div>
                                        </div>
                                        <div *ngIf="!row.isActive" class="inactive-pod">
                                            <app-icon name="fal-times-circle"></app-icon>
                                            {{ 'Not active to this day'|i18n }}
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="tip">
                                <td fxFlex mat-cell class="cell last-cell" *matCellDef="let row">
                                    <div [ngClass]="row.generatesTip ? 'active-pod' : 'inactive-pod'">
                                        <app-icon
                                                [name]="row.generatesTip ? 'fal-check-circle' : 'fal-times-circle'"></app-icon>
                                        {{ (row.generatesTip ? 'Generates TIP' : 'Doesn\'t generate TIP')|i18n }}
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="expandedDetail">
                                <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                                    <div [@detailExpand]="row === currentPod ? 'expanded' : 'collapsed'"
                                         class="plant-details-container" fxLayout="row" fxFlex>
                                        <div *ngIf="currentPod" class="plant-details" fxLayout="row" fxFlex>
                                            <!-- plant list -->
                                            <div fxLayout="column" fxFlex="20" fxLayoutGap="15px">
                                                <div *ngFor="let plant of currentPod.namedPlants" fxLayout="row"
                                                     fxLayoutAlign="start start"
                                                     fxLayoutGap="10px">
                                                    <div fxLayout="column" fxLayoutGap="10px">
                                                        <div fxLayout="row" fxLayoutAlign="start center"
                                                             fxLayoutGap="10px">
                                                            <app-icon icon-color-h name="fal-solar-panel"></app-icon>
                                                            <div class="txt-h-18-7">{{ plant.name }}</div>
                                                        </div>
                                                        <div [ngClass]="plant.generatesTip ? 'active-pod' : 'inactive-pod'"  fxLayoutGap="10px">
                                                            <app-icon
                                                                    [name]="plant.generatesTip ? 'fal-check-circle' : 'fal-times-circle'">
                                                            </app-icon>
                                                            {{ (plant.generatesTip ? 'Generates TIP' : 'Doesn\'t generate TIP')|i18n }}
                                                        </div>
                                                    </div>
                                                    <div *ngIf="!plant.isActive" class="inactive-pod mt-3">
                                                        <app-icon name="fal-times-circle"></app-icon>
                                                        {{ 'Not active to this day'|i18n }}
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- tiles column -->
                                            <div fxLayout="column" fxFlex fxLayoutGap="20px">

                                                <!-- first row-->
                                                <div fxLayout="row">
                                                    <!-- rei -->
                                                    <div fxLayout="column" fxLayoutGap="20px" fxFlex class="tile">
                                                        <div class="txt-s-16-7">{{ 'Injected energy withdrawal'|i18n }}</div>
                                                        <div fxLayout="column" fxLayoutGap="50px">
                                                            <div fxLayout="column">
                                                                <div fxLayout="row" fxLayoutGap="10px">
                                                                    <app-icon icon-color-h
                                                                              name="fal-piggy-bank"></app-icon>
                                                                    <div class="txt-h-12-4">{{ 'Injected energy'|i18n }}</div>
                                                                    <app-icon icon-color-h name="fas-info-circle"
                                                                              [title]="'It is the electricity actually fed into the grid plus conventional loss coefficients, as provided for in Article 76 of ARERA\'s TIS, to take into account electricity losses on transmission and distribution grids and used for energy retirement purposes.'|i18n">
                                                                    </app-icon>
                                                                </div>
                                                                <div class="txt-h-16-7">{{
                                                                        keepYourSecrets || !arePlantsActive(currentPod) ?
                                                                            '-' : currentPod.injected_energy|niceValue:'kWh'
                                                                    }}
                                                                </div>
                                                            </div>
                                                            <div fxLayout="column">
                                                                <div fxLayout="row" fxLayoutGap="10px">
                                                                    <app-icon icon-color-h
                                                                              name="fal-piggy-bank"></app-icon>
                                                                    <div class="txt-h-12-4">{{ 'Incentive'|i18n }}</div>
                                                                </div>
                                                                <div class="txt-h-16-7">{{
                                                                        keepYourSecrets || !arePlantsActive(currentPod) ?
                                                                            '-' : currentPod.rei|niceValue:'€'
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div fxFlex="1"></div>
                                                    <!-- tip and cacv -->
                                                    <div fxLayout="column" fxFlex="60" fxLayoutGap="30px" class="tile">
                                                        <div class="txt-s-16-7"
                                                             [innerHTML]="'Generated TIP and {0}'|i18n:CACV_STRING"></div>
                                                        <div fxLayout="column" fxLayoutGap="50px">
                                                            <div fxLayout="row" fxLayoutGap="30px">
                                                                <div fxLayout="column">
                                                                    <div fxLayout="row" fxLayoutGap="10px">
                                                                        <app-icon icon-color-h
                                                                                  name="fal-piggy-bank"></app-icon>
                                                                        <div class="txt-h-12-4">{{ 'Effective injected energy'|i18n }}</div>
                                                                        <app-icon icon-color-h name="fas-info-circle"
                                                                                  [title]="'Electricity actually fed in from feed-in points without the addition of conventional loss coefficients and used to determine shared energy.'|i18n">
                                                                        </app-icon>
                                                                    </div>
                                                                    <div [ngClass]="currentPod.gse ? 'txt-b-16-7' : 'txt-h-16-7'">{{
                                                                            keepYourSecrets || !arePlantsActive(currentPod) ? '-' :
                                                                                currentPod.effective_injected_energy|niceValue:'kWh'
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div fxLayout="column" *ngIf="nonIncentivizedPlants">
                                                                    <div fxLayout="row" fxLayoutGap="10px">
                                                                        <app-icon icon-color-h
                                                                                  name="fal-piggy-bank"></app-icon>
                                                                        <div class="txt-h-12-4">{{ 'Incentive effective injected energy'|i18n }}</div>
                                                                    </div>
                                                                    <div [ngClass]="currentPod.gse ? 'txt-b-16-7' : 'txt-h-16-7'">{{
                                                                            keepYourSecrets || !arePlantsActive(currentPod) ? '-' :
                                                                                currentPod.incentive_effective_injected_energy|niceValue:'kWh'
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div fxLayout="column">
                                                                    <div fxLayout="row" fxLayoutGap="10px">
                                                                        <app-icon icon-color-h
                                                                                  name="fal-piggy-bank"></app-icon>
                                                                        <div class="txt-h-12-4">{{ 'Shared energy'|i18n }}</div>
                                                                    </div>
                                                                    <div [ngClass]="currentPod.gse ? 'txt-b-16-7' : 'txt-h-16-7'">{{
                                                                            keepYourSecrets || !arePlantsActive(currentPod) ? '-' :
                                                                                currentPod.shared_energy|niceValue:'kWh'
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div fxLayout="column" *ngIf="nonIncentivizedPlants">
                                                                    <div fxLayout="row" fxLayoutGap="10px">
                                                                        <app-icon icon-color-h
                                                                                  name="fal-piggy-bank"></app-icon>
                                                                        <div class="txt-h-12-4">{{ 'Incentive shared energy'|i18n }}</div>
                                                                    </div>
                                                                    <div [ngClass]="currentPod.gse ? 'txt-b-16-7' : 'txt-h-16-7'">{{
                                                                            keepYourSecrets || !arePlantsActive(currentPod) ? '-' :
                                                                                currentPod.incentive_shared_energy|niceValue:'kWh'
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div fxLayout="row" fxLayoutGap="30px">
                                                                <div fxLayout="row" fxLayoutGap="50px">
                                                                    <div fxLayout="column">
                                                                        <div fxLayout="row" fxLayoutGap="10px">
                                                                            <app-icon icon-color-h
                                                                                      name="fal-piggy-bank"></app-icon>
                                                                            <div class="txt-h-12-4"
                                                                                 [innerHTML]="'Gross {0}'|i18n:CACV_STRING"></div>
                                                                        </div>
                                                                        <div class="txt-h-16-7">
                                                                            {{ keepYourSecrets || !arePlantsActive(currentPod) || !isDefined(currentPod.gross_c_acv) ? '-' : currentPod.gross_c_acv|niceValue:'€' }}
                                                                        </div>
                                                                    </div>
                                                                    <div fxLayout="column">
                                                                        <div fxLayout="row" fxLayoutGap="10px">
                                                                            <app-icon icon-color-h
                                                                                      name="fal-piggy-bank"></app-icon>
                                                                            <div class="txt-h-12-4"
                                                                                 [innerHTML]="'Net {0}'|i18n:CACV_STRING"></div>
                                                                        </div>
                                                                        <div class="txt-h-16-7">
                                                                            {{ keepYourSecrets || !arePlantsActive(currentPod) || !isDefined(currentPod.net_c_acv) ? '-' : currentPod.net_c_acv|niceValue:'€' }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div fxLayout="row" fxLayoutGap="50px"
                                                                     fxLayoutAlign="start center">
                                                                    <div fxLayout="column">
                                                                        <div fxLayout="row" fxLayoutGap="10px">
                                                                            <app-icon icon-color-h
                                                                                      name="fal-piggy-bank"></app-icon>
                                                                            <div class="txt-h-12-4">{{ 'Gross TIP'|i18n }}</div>
                                                                        </div>
                                                                        <div class="txt-h-16-7">
                                                                            {{ keepYourSecrets || !arePlantsActive(currentPod) || !isDefined(currentPod.gross_tip) ? '-' : currentPod.gross_tip|niceValue:'€' }}
                                                                        </div>
                                                                    </div>
                                                                    <div fxLayout="column">
                                                                        <div fxLayout="row" fxLayoutGap="10px">
                                                                            <app-icon icon-color-h
                                                                                      name="fal-piggy-bank"></app-icon>
                                                                            <div class="txt-h-12-4">{{ 'Net TIP'|i18n }}</div>
                                                                        </div>
                                                                        <div class="txt-h-16-7">
                                                                            {{ keepYourSecrets || !arePlantsActive(currentPod) ? '-' : currentPod.net_tip|niceValue:'€' }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                            <app-icon icon-color-h name="fal-solar-panel"></app-icon>
                                                            <div class="txt-h-12-4">{{ 'Share dedicated to you:'|i18n }}</div>
                                                            <div *ngIf="!showDedicatedShare" class="txt-h-14-4">-</div>
                                                            <ng-container *ngIf="showDedicatedShare">
                                                                <div class="txt-h-14-4">{{ tip }}</div>
                                                                <div *ngIf="showCacv" fxLayout="row" fxLayoutGap="5px" class="txt-h-14-4">
                                                                    <div>+</div>
                                                                    <div [innerHTML]="cacv" class="ml-5"></div>
                                                                    <div>{{ plantCacv }}</div>
                                                                </div>
                                                                <div class="txt-h-20-7">{{ dedicatedShare }}</div>
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                    <div fxFlex="1"></div>
                                                    <!-- sharing donut chart -->
                                                    <div *ngIf="!keepYourSecrets  && arePlantsActive(currentPod) "
                                                         fxLayout="column" class="tile">
                                                        <div fxLayout="row" fxLayoutAlign="start center"
                                                             fxLayoutGap="10px">
                                                            <div class="txt-h-16-7">{{ 'Sharing from injection'|i18n }}</div>
                                                            <app-icon icon-color-h name="fas-info-circle"
                                                                      [title]="'Percentage of injected energy that became shared energy.'|i18n"></app-icon>
                                                        </div>
                                                        <div *ngIf="donutChart">
                                                            <apx-chart
                                                                    [series]="donutChart['series']"
                                                                    [chart]="donutChart['chart']"
                                                                    [title]="donutChart['title']"
                                                                    [legend]="donutChart['apexLegends']"
                                                                    [colors]="donutChart['colors']"
                                                                    [dataLabels]="donutChart['dataLabels']"
                                                                    [plotOptions]="donutChart['plotOptions']"
                                                                    [tooltip]="donutChart['tooltip']">
                                                            </apx-chart>
                                                        </div>
                                                        <div fxLayout="row" [fxLayoutAlign]="currentPod.gse ? 'start start' : 'start center'" fxLayoutGap="10px"
                                                             *ngIf="nonIncentivizedPlants">
                                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                                <app-icon icon-color-h name="fal-piggy-bank"></app-icon>
                                                                <div *ngIf="!keepYourSecrets" class="txt-h-12-4">{{ 'of which incentive'|i18n }}:</div>
                                                            </div>
                                                            <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                                            <div fxLayout="column" fxLayoutGap="10px">
                                                                <div *ngIf="!keepYourSecrets" [ngClass]="currentPod.gse ? 'txt-e-18-7' : 'txt-e-26-7'">
                                                                    {{ currentPod.estimated_incentive_shared_energy_ratio*100|niceValue:'%' }}
                                                                </div>
                                                                <ng-container *ngIf="currentPod.gse">
                                                                    <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                                                    <div *ngIf="!keepYourSecrets"
                                                                         class="txt-acc-24-7">{{ currentPod.incentive_shared_energy_ratio*100|niceValue:'%' }}
                                                                    </div>
                                                                </ng-container>
                                                            </div>
                                                            <app-icon icon-color-h name="fas-info-circle"
                                                                      [title]="'Performance computed on incentivized shared energy'|i18n">
                                                            </app-icon>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- graph row -->
                                                <div *ngIf="!keepYourSecrets  && arePlantsActive(currentPod) "
                                                     class="tile">
                                                    <ng-container
                                                            *ngTemplateOutlet="energySharingCharts; context: {quantities: energySharing}">
                                                    </ng-container>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="app-row"
                                [ngClass]="{'app-expanded-row': currentPod === row}"
                                (click)="onSelectPlant(row)">
                            </tr>
                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                class="app-detail-row app-border-row"
                                [ngClass]="{'app-expanded-row': currentPod === row}">
                            </tr>
                        </table>
                    </ng-container>
                    <div *ngIf="pods.length === 0" fxLayout="row" fxLayoutAlign="center" class="mt-20">
                        {{ 'No plants found'|i18n }}
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #loadingPlants>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{ 'Loading plants'|i18n }}...</span>
    </div>
</ng-template>

<ng-template #unviewableEntity>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{ 'Insufficient permissions to view this resource'|i18n }}
    </div>
</ng-template>

<!-- ec waiting for approval info -->
<ng-template #ecWaitingForApproval>
    <div fxLayout="column" class="p-30" fxLayoutAlign="center center">
        <div class="txt-h-24-7">{{ 'Community waiting for activation'|i18n }}</div>
        <app-icon icon-color-h name="fal-clock" fxFlex="60" class="clock-icon mt-30 mb-30"></app-icon>
        <ng-container *ngIf="inactiveEc">
            <div class="txt-s-16-4">{{ 'This community has no activation date yet.'|i18n }}</div>
            <div class="txt-s-16-4">{{ 'As soon as the community is activated, you will see economic and energy data here.'|i18n }}</div>
        </ng-container>
        <ng-container *ngIf="!inactiveEc">
            <div class="txt-s-16-4">{{ 'This community will be activated by {0}.'|i18n:(billingPeriodCfg.pastDate|i18nDate) }}</div>
            <div class="txt-s-16-4">{{ 'Economic data will be available from that day.'|i18n }}</div>
        </ng-container>
        <div mat-dialog-actions class="dialog-actions mt-30">
            <button app-primary-button [mat-dialog-close]="true">
                {{ 'Ok'|i18n }}
            </button>
        </div>
    </div>
</ng-template>


<ng-template #energySharingCharts let-quantities="quantities">
    <div *ngIf="quantities" fxLayout="column" class="chart-quantities">
        <div *ngFor="let q of quantities" fxLayout="column" fxLayoutAlign="start stretch">
            <div fxLayout="row" fxLayoutAlign="start" class="quantity-name txt-h-16-7">
                {{ q.name }}
            </div>
            <ng-container *ngIf="q.data.length">
                <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="1rem" class="mt-8">
                    <div *ngFor="let d of q.data" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.25rem">
                        <span [style]="{'background-color': d.style.color}" class="legend-line"
                              [ngClass]="!!d.style.dashed ? 'dashed' : ''"></span>
                        <span>{{ d.name|i18n }}</span>
                    </div>
                </div>
                <div class="chart-quantity">
                    <app-line-chart [data]="q.data"
                                    [margins]="{left:75, right: -20}"
                                    [yTickFormatter]="q.uom|yTickFormatter"
                                    [tooltipFormatter]="q.uom|tooltipFormatter:timeDelta"
                                    [xGrid]="true"
                                    [yGrid]="true"
                                    [gridColor]="getGridColor(sharedConfig)"
                                    [tooltipBorderColor]="getTooltipBorderColor(sharedConfig)"
                                    [tooltipBackgroundColor]="getTooltipBackgroundColor(sharedConfig)"
                                    [selectionLineColor]="getSelectionLineColor(sharedConfig)"
                                    [xTickSpace]="80"
                                    [yTickSpace]="30"
                                    [resizeTrigger]="contentResize">
                    </app-line-chart>
                </div>
            </ng-container>
            <div *ngIf="!q.data.length" fxLayout="row" fxLayoutAlign="center" class="mt-24">
                <app-icon icon-color-s name="fal-exclamation-circle"></app-icon>&nbsp;
                <span class="pl-8">{{ 'No data'|i18n }}</span>
            </div>
        </div>
    </div>
</ng-template>
